import { Component } from '@angular/core';
import { AutorizacionService } from '../services/autorizacion.service';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent {
  registro:any={};

  constructor(private autorizacionService: AutorizacionService) { 
    //this.autorizacionService.registro('test@test.com','12345');
  }

  registrar(){
    this.autorizacionService.registro(this.registro.login,this.registro.password);
  }
}



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/registro/registro.component.ts